// // countryUtils.js
// import countries from "i18n-iso-countries";
// import enLocale from "i18n-iso-countries/langs/en.json";

// // Register the locale
// countries.registerLocale(enLocale);

// const NOISE_WORDS = new Set(["of", "the", "and", "in", "at", "republic", "democratic"]);

// export const KNOWN_COUNTRIES = new Set(
//     Object.values(countries.getNames("en", { select: "official" }))
//         .flatMap(name => name.split(/[\s,()/-]+/))
//         .filter(w => w.length >= 2)
//         .filter(w => !NOISE_WORDS.has(w.toLowerCase())) // Filter out noise here!
// );

// // Export the library if you need it elsewhere
// export { countries };

// countryUtils.js
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import deLocale from "i18n-iso-countries/langs/de.json";
import frLocale from "i18n-iso-countries/langs/fr.json";
import esLocale from "i18n-iso-countries/langs/es.json";
import itLocale from "i18n-iso-countries/langs/it.json";
import ptLocale from "i18n-iso-countries/langs/pt.json";
import zhLocale from "i18n-iso-countries/langs/zh.json";
import arLocale from "i18n-iso-countries/langs/ar.json";

// 1. Register all locales
[enLocale, deLocale, frLocale, esLocale, itLocale, ptLocale, zhLocale, arLocale]
    .forEach(locale => countries.registerLocale(locale));

// 2. Define multilingual noise words (translated common prepositions/articles)
const NOISE_WORDS = new Set([
    "of", "the", "and", "in", "at", "republic", "democratic",
    "und", "der", "die", "das", "le", "la", "les", "de", "del", "el", "los", "las", "da", "o"
]);

// 3. Generate the comprehensive Set
const locales = ["en", "de", "fr", "es", "it", "pt", "zh", "ar"];

export const KNOWN_COUNTRIES = new Set(
    locales.flatMap(lang => Object.values(countries.getNames(lang)))
        .flatMap(name => name.split(/[\s,()/-]+/))
        .filter(w => w.length >= 2)
        .filter(w => !NOISE_WORDS.has(w.toLowerCase()))
);

export { countries };